module.exports = __webpack_public_path__ + "static/img/avatar-s-23.6128b34a.jpg";